/* eslint-disable */
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";

import { OrderProps } from "store/modules/Orders/types.store";
import {
  formatCurrency,
  formatPlacedOriginLabel,
  formatProductNameAndDescription,
  formatStreetAddress,
  totalPrices,
  voucherFunction,
} from "utils/formatByText";
import { formatTaxDocument } from "utils/taxDocument";

import * as Styled from "./styles";

interface DivCopyComponentProps {
  data: OrderProps;
}

const DivCopyComponent: React.FC<DivCopyComponentProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Styled.ContentCopy id="order-content">
      {data && (
        <>
          <div>
            <strong>ID do pedido</strong>: {data?.id}
          </div>
          <br />
          <div>
            <strong>Canal pedido</strong>:{" "}
            {formatPlacedOriginLabel(data?.placedOrigin)}
          </div>
          <br />
          <div>
            <strong>Id da revenda</strong>:{" "}
            {data?.dealer?.id ?? "Não informado"}
          </div>
          <br />
          <div>
            <strong>Nome da revenda</strong>:{" "}
            {data?.dealer?.name ?? "Não informado"}
          </div>
          <br />
          <div>
            <strong>Área de cobertura</strong>:{" "}
            {data?.coverageArea?.name ?? "Não informado"}
          </div>
          <br />
          <div>
            <strong>CPF ou CNPJ</strong>:{" "}
            {formatTaxDocument(data?.fiscal?.document) || "Não informado"}
          </div>
          <br />
          <div>
            <strong>Nome do Cliente</strong>:{" "}
            {data?.consumer?.name ?? "Não informado"}
          </div>
          <br />
          <div>
            <strong>Endereço de entrega</strong>:{" "}
            {[
              formatStreetAddress(data?.delivery?.address),
              data?.delivery?.address?.district?.trim(),
            ]
              .filter(Boolean)
              .join(", ")}
          </div>

          <br />
          <div>
            <strong>Observação</strong>:{" "}
            {data?.delivery?.remarks || "Não informado"}
          </div>
          <br />
          <div>
            <strong>Link para o mapa</strong>:{" "}
            {data?.delivery?.address?.latitude &&
            data?.delivery?.address?.longitude
              ? `https://www.google.com.br/maps/@${data?.delivery?.address?.latitude},${data?.delivery?.address?.longitude}?entry=ttu`
              : "Não informado"}
          </div>
          <br />
          <div>
            <strong>Data e hora do pedido</strong>:{" "}
            {data?.createdAt &&
              `${format(
                new Date(data?.createdAt || ""),
                "HH:mm",
              )} do dia ${format(new Date(data?.createdAt || ""), "dd/MM/yy")}`}
          </div>
          <br />
          <div>
            <strong>Produto e preço</strong>:{" "}
            {data?.items?.map((product) => (
              <Styled.ContainerRowsProducts>
                <div>{`${product?.quantity} ${formatProductNameAndDescription(
                  product?.name,
                  product?.description,
                )}`}</div>
                <div>
                  {formatCurrency(Number(product?.unitPrice))}
                </div>
              </Styled.ContainerRowsProducts>
            ))}
          </div>
          <br />
          <div>
            <strong>Desconto</strong>:{" "}
            {voucherFunction(data)?.length
              ? voucherFunction(data)
              : "Não informado"}
          </div>
          <br />
          <div>
            <strong>Valor total a receber do cliente</strong>:{" "}
            {formatCurrency(
              Number(totalPrices(data) - (data?.discount ? data?.discount : 0)),
            )}
          </div>
          <br />
          <div>
            <strong>Forma de pagamento</strong>:{" "}
            {`
             ${data?.payment?.type ?? ""} (${
              data?.payment?.description === "Dinheiro" &&
              data?.payment?.change > 0
                ? `${t("money")} ${t(
                    "changeTo",
                  )} ${formatCurrency(
                    Number(data?.payment?.change),
                  )}`
                : data?.payment?.description
            })`}
          </div>
        </>
      )}
    </Styled.ContentCopy>
  );
};

export default DivCopyComponent;
